import type { App, DirectiveBinding } from 'vue'
import { useAuthStore } from '@/stores/auth.store'
import type { RoleName } from '@/auth/roles'

type RoleBinding =
  | RoleName
  | RoleName[]
  | {
      any?: RoleName[]
      all?: RoleName[]
      not?: RoleName[]
    }

function isAllowed(bindingValue: RoleBinding): boolean {
  const auth = useAuthStore()

  if (typeof bindingValue === 'string') {
    return auth.hasRole(bindingValue)
  }

  if (Array.isArray(bindingValue)) {
    return auth.hasAnyRole(bindingValue)
  }

  if (bindingValue.not?.some((role) => auth.hasRole(role))) {
    return false
  }

  if (bindingValue.all && !auth.hasAllRoles(bindingValue.all)) {
    return false
  }

  return !(bindingValue.any && !auth.hasAnyRole(bindingValue.any))
}

function updateVisibility(el: HTMLElement, binding: DirectiveBinding<RoleBinding>) {
  const allowed = isAllowed(binding.value)
  el.style.display = allowed ? '' : 'none'
}

export function registerRoleDirective(app: App) {
  app.directive('role', {
    mounted(el, binding) {
      updateVisibility(el as HTMLElement, binding)
    },
    updated(el, binding) {
      updateVisibility(el as HTMLElement, binding)
    },
  })
}
